import {
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";

const EditState = ({ data }) => {
    const { isLoading, isError, errors, isSuccess } = useSelector(
        (state) => state.designer_licens
    );
    const dispatch = useDispatch();

    // get all states
    useEffect(() => {
        const getStates = async () => {
            // await dispatch(getAllState());
            // await dispatch(resetState());
        };
        getStates();
    }, [dispatch]);

    const { states } = useSelector((state) => state.AllStates);

    //get All States
    const AllStates = states?.data?.states;
    const formik = useFormik({
        initialValues: {
            holder_name: data.holder_name,
            license_number: data.license_number,
            state_id: data.state_id,
            designer_id: data.designer_id,
        },
        onSubmit: (values) => {
            if (!data) {
                // dispatch(CreateLicens(values));
            }
            // dispatch(UpdateSingleLicens({ ...values, id: data.id }));
        },
    });

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                // await dispatch(licensReset());
            };
            reset();
        }
        if (isSuccess) {
            toast.success("The data has been modified successfully");
            const GetDesigners = () => {
                // dispatch(GetAllDesigners());
                // dispatch(designersReset());
            };
            GetDesigners();
        }
        const resetWhenOpen = () => {
            // dispatch(licensReset());
        };
        resetWhenOpen();
    }, [isError, errors, dispatch, isSuccess]);

    useEffect(() => {
        formik.values.email = data.email;
        formik.values.address = data.address;
        formik.values.phone = data.phone;
        formik.values.state_id = data.state_id;
    }, [data, formik.values])

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <>
                    <FormHeading> Edit State </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2}>
                                <Grid mt={2} container columns={12}>
                                        <Grid
                                            container
                                            columns={12}
                                            spacing={3}
                                        >
                                            <Grid item mb={1} xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    label="Email"
                                                    value={formik.values.email}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                />
                                            </Grid>

                                            <Grid item mb={1} xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    id="phone"
                                                    name="phone"
                                                    type="phone"
                                                    label="Phone"
                                                    value={formik.values.phone}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                />
                                            </Grid>

                                            <Grid item mb={1} xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    id="address"
                                                    name="address"
                                                    type="address"
                                                    label="Address"
                                                    value={
                                                        formik.values.address
                                                    }
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                />
                                            </Grid>

                                            <Grid item mb={1} xs={12} md={6}>
                                                <FormControl
                                                    fullWidth
                                                    required={true}
                                                >
                                                    <InputLabel id="demo-simple-select-label">
                                                        State
                                                    </InputLabel>
                                                    <Select
                                                        id="state_id"
                                                        name="state_id"
                                                        label="State"
                                                        required
                                                        value={
                                                            formik.values
                                                                .state_id
                                                        }
                                                        onChange={
                                                            formik.handleChange
                                                        }
                                                    >
                                                        {AllStates?.map(
                                                            (key) => (
                                                                <MenuItem
                                                                    key={key.id}
                                                                    value={
                                                                        key.id
                                                                    }
                                                                >
                                                                    {key.name}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "Loading..." : "Edit"}
                        </PrimaryButton>
                    </form>
                </>
            )}
        </>
    );
};

export default EditState;
